import React, { useState } from "react";
import "./Dropdown.css";
import FontAwesome from "react-fontawesome";
import { Link } from "react-router-dom";
import { lightBlue } from "@material-ui/core/colors";
function Dropdown({ onClick, MenuItems, className }) {
  const [click, setClick] = useState(false);
  const handleClick = () => {
    setClick(!click);
  };
  const handelonClick = (event) => {

    setClick(false);
    onClick(event);
  };
  return (

    //style={{ fontSize: "13px" }} style = {{color: Tomato}}
    <>
      <ul
        onClick={handleClick}
        className={click ? className + " clicked" : className}
      >
        {MenuItems.map((item, index) => {
          return (
            <li key={index}>
              <Link
                className={item.iconClassName}
                to={item.path}
                onClick={() => handelonClick(item.path)}
              >
                  <span className="me-2" >  {item.icon ?  <FontAwesome name={item.icon} /> :<FontAwesome name="arrow-right" /> } </span>
                {item.title}
              </Link>
            </li>
          );
        })}
      </ul>
    </>
  );
}
export default Dropdown;
